// Authentication service that calls backend API

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface LoginResponse {
  success: boolean;
  user?: {
    username: string;
    bzs_username: string;
  };
  token?: string;
  message?: string;
}

// API URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5003';

export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
  try {
    console.log('Logging in with:', credentials.username);
    
    // Store username directly in localStorage as a backup
    localStorage.setItem('username', credentials.username);
    
    // Simple fetch with a 10 second timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
    
    const response = await fetch(`${API_URL}/api/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    
    const data = await response.json();
    
    if (!response.ok) {
      console.log('Login failed:', data);
      return {
        success: false,
        message: data.message || 'Nesprávne meno alebo heslo',
      };
    }
    
    console.log('Login successful for user:', data.user?.username);
    return data;
  } catch (error: any) {
    console.error('Login error:', error);
    
    // Handle different error types
    if (error.name === 'AbortError') {
      return {
        success: false,
        message: 'Server nereaguje. Skúste znova.',
      };
    }
    
    return {
      success: false,
      message: 'Problém s pripojením k serveru. Skontrolujte sieťové pripojenie.',
    };
  }
}; 